import { render } from "./Returns.vue?vue&type=template&id=4d093809&scoped=true"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"

import "./custom-returns.scss?vue&type=style&index=0&id=4d093809&lang=scss&scoped=true"
import "./Returns.vue?vue&type=style&index=1&id=4d093809&lang=scss&scoped=true"
import "./Returns.vue?vue&type=style&index=2&id=4d093809&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d093809"]])

export default __exports__